import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import { OptimizelySubitoContext } from '@sbt-web/houston-wrapper';
import { AdItem } from '@sbt-web/network/types';
const TOGGLE = 'it.subito.web.premium-ads.ancillary-services';
const useAncillaryServicesStatus = adItem => {
  const $ = _c(6);
  const {
    optimizely
  } = useContext(OptimizelySubitoContext);
  const [enabled, setEnabled] = useState(adItem.advertiser.proPremiumDetailEnabled !== true);
  let t0;
  if ($[0] !== adItem.advertiser.proPremiumDetailEnabled || $[1] !== optimizely) {
    t0 = () => {
      if (adItem.advertiser.proPremiumDetailEnabled === true && optimizely) {
        optimizely.onReady().then(() => {
          setEnabled(optimizely.isFeatureEnabled(TOGGLE));
        });
      }
    };
    $[0] = adItem.advertiser.proPremiumDetailEnabled;
    $[1] = optimizely;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== adItem || $[4] !== optimizely) {
    t1 = [adItem, optimizely];
    $[3] = adItem;
    $[4] = optimizely;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(t0, t1);
  return enabled;
};
export { useAncillaryServicesStatus, TOGGLE };